/*
 * Rebuild migrated Magento `.fotorama` galleries (commercial pages) into a
 * main-image + thumbnail-strip gallery with Prev/Next, like the original
 * fotorama. Each source <a href> is the large image and its <img> is the thumb.
 * Falls back to the plain CSS scroller if JS doesn't run. Scoped to .mig-page.
 */
(function () {
  function btn(cls, label, glyph) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mig-carousel-btn ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = glyph;
    return b;
  }

  // Append a Shopify CDN resize param so we don't download full-size originals.
  function withWidth(url, n) {
    if (!url || url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + n;
  }

  function build(f) {
    if (f.dataset.migNav) return;
    f.dataset.migNav = '1';

    var slides = Array.prototype.slice.call(f.querySelectorAll('a')).map(function (a) {
      var img = a.querySelector('img');
      return {
        main: a.getAttribute('href') || (img && img.getAttribute('src')),
        thumb: (img && img.getAttribute('src')) || a.getAttribute('href'),
        alt: (img && img.alt) || ''
      };
    }).filter(function (s) { return s.main; });
    if (!slides.length) return;

    var gallery = document.createElement('div');
    gallery.className = 'mig-gallery';

    var stage = document.createElement('div');
    stage.className = 'mig-gallery-main';
    var mainImg = document.createElement('img');
    mainImg.className = 'mig-gallery-img';
    mainImg.loading = 'lazy';
    var prev = btn('mig-prev', 'Previous image', '‹');
    var next = btn('mig-next', 'Next image', '›');
    stage.appendChild(prev);
    stage.appendChild(mainImg);
    stage.appendChild(next);

    var thumbs = document.createElement('div');
    thumbs.className = 'mig-gallery-thumbs';
    var thumbBtns = slides.map(function (s, i) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'mig-thumb';
      var ti = document.createElement('img');
      ti.src = withWidth(s.thumb, 240);
      ti.alt = s.alt;
      ti.loading = 'lazy';
      t.appendChild(ti);
      t.addEventListener('click', function () { go(i); });
      thumbs.appendChild(t);
      return t;
    });

    gallery.appendChild(stage);
    if (slides.length > 1) gallery.appendChild(thumbs);
    f.parentNode.insertBefore(gallery, f);
    f.style.display = 'none';

    var idx = 0;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      mainImg.src = withWidth(slides[idx].main, 1000);
      mainImg.alt = slides[idx].alt;
      thumbBtns.forEach(function (b, j) { b.classList.toggle('is-active', j === idx); });
      var active = thumbBtns[idx];
      if (active) active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    if (slides.length < 2) { prev.hidden = true; next.hidden = true; }
    go(0);
  }

  /*
   * YouTube facades. Migrated pages embed each video as a live <iframe>, and
   * the DIY Visual Guides page has 37 of them — enough players to exhaust
   * memory and crash the tab on iOS Safari ("A problem repeatedly occurred").
   * main-page.liquid parks the URL on data-src so nothing loads; here we show a
   * thumbnail + play button and only start the player on click.
   */
  var YT_ID = /youtube(?:-nocookie)?\.com\/embed\/([\w-]{6,})/;

  // Widths to offer the browser. The embed is 1050px at its widest, and the
  // source thumbnails are 1280x720, so there's nothing to gain above 1000.
  var THUMB_WIDTHS = [400, 600, 800, 1000];

  /*
   * Point the poster at our copy of the thumbnail in Files, which Shopify's CDN
   * will resize per viewport — YouTube only serves fixed sizes, so hotlinking
   * means shipping the full 1280px file to a 390px phone. Falls back to
   * YouTube's CDN for any video whose thumbnail was never uploaded.
   *
   * mig- is the store's prefix for assets pulled over from Magento, so the team
   * can filter them in Content > Files; the video id keeps the name unique.
   */
  function poster(img, base, id) {
    if (!base) {
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      return;
    }
    var file = base + 'mig-yt-' + id + '.jpg';
    img.src = file + '?width=1000';
    img.srcset = THUMB_WIDTHS.map(function (w) {
      return file + '?width=' + w + ' ' + w + 'w';
    }).join(', ');
    img.sizes = '(min-width: 990px) 1050px, 100vw';
    img.addEventListener('error', function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    }, { once: true });
  }

  function facade(frame, thumbBase) {
    var src = frame.getAttribute('data-src');
    var m = YT_ID.exec(src || '');
    if (!m) return;
    var id = m[1];
    var title = frame.getAttribute('title') || 'YouTube video player';

    var box = document.createElement('button');
    box.type = 'button';
    box.className = 'yt-facade';
    box.setAttribute('aria-label', 'Play video: ' + title);

    var img = document.createElement('img');
    img.alt = title;
    img.loading = 'lazy';
    img.decoding = 'async';
    poster(img, thumbBase, id);
    box.appendChild(img);

    var play = document.createElement('span');
    play.className = 'yt-facade-play';
    play.setAttribute('aria-hidden', 'true');
    box.appendChild(play);

    box.addEventListener('click', function () {
      frame.removeAttribute('data-src');
      frame.setAttribute('src', src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1');
      frame.hidden = false;
      box.parentNode.replaceChild(frame, box);
    });

    frame.hidden = true;
    frame.parentNode.replaceChild(box, frame);
  }

  function run() {
    document.querySelectorAll('.mig-page .fotorama').forEach(build);
    var host = document.querySelector('[data-yt-thumb-base]');
    var thumbBase = host && host.dataset.ytThumbBase;
    document.querySelectorAll('iframe[data-src*="/embed/"]').forEach(function (frame) {
      facade(frame, thumbBase);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
